module.exports = __webpack_public_path__ + "media/fonts/galapagos-c-semibold-51a48111d0f35c7841da3a587ed68bad.woff";